import { STOCK_TAKING_CAR_MANAGMENT_SAVE_BEGIN } from "../constants"

export function saveTakingCarManagment(takingCarManagmentData){
    return (dispatch) =>{
        dispatch({
            type: STOCK_TAKING_CAR_MANAGMENT_SAVE_BEGIN,
            data: takingCarManagmentData
        })
    }
}